module.exports = __webpack_public_path__ + "static/media/contratos.09accb86.svg";